import type { Edition } from "./types";

export const saopaulo2026: Edition = {
  slug: "saopaulo-2026",
  city: "São Paulo",
  editionDates: "23a25SET",
  eventStartDate: "2026-09-23",
  logoAsset: "/editions/saopaulo-2026/logo.png",
  backgroundAsset: "/editions/saopaulo-2026/tdc-video-background.mp4",
};
